import { useEffect, useState } from "react";
import { Profile } from "../models/profile";
import { Header } from "../components/header";
import { useParams } from "react-router-dom";
import data from "../data/certificates.json"

export const Certificate = () => {
  const { id } = useParams();
  const [profile, setProfile] = useState<Profile>();
  
  const getProfile = (id: string) => {
    const certificate = data.certificates.find(c => c.id === id);
    setProfile(certificate);
  }

  useEffect(() => {
    if (id) {
      getProfile(id);
    }
  }, [id]);

  return (
    <div className="main background">
      <Header/>

      <main className="px-4 mb-auto">
        {profile && (
          <div className="fade-in p-7 md:p-10 rounded-lg md:rounded-xl bg-neutral-900 bg-opacity-70 backdrop-blur-sm wrapper">
            <div className="flex flex-wrap items-start gap-x-6 gap-y-3 mb-6 md:mb-8">
              <h1 className="text-white">{profile.name}</h1>
              <div className="label">Підтверджено</div>
            </div>
            
            <p className="text-lg text-neutral-50 max-w-[580px] mb-4">
              офіційний партнер <b>IDM.UA</b> — теплові насоси з Австрії,
              та має право на <b>проєктування інженерних мереж</b> на території України.
            </p>
          </div>
        )}
      </main>

      <p className="text-center text-sm py-2 px-2 text-neutral-100 bg-neutral-800 bg-opacity-70">
        Ексклюзивне представництво IDM ENERGIESYSTEME GMBH в Україні Директор ТОВ «Неотепло»
      </p>
    </div>
  );
}